import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import InputForm from "src/components/forms/InputForm";
import SwipetypeForm from "src/components/forms/SwipetypeForm";
import SwitchForm from "src/components/forms/SwitchForm";
import Title from "src/components/Title";
import API from "src/services/api";

const TaggroupAddEditSite = () => {
  // Parameter tag_id aus URL auslesen
  const { taggroup_id } = useParams();
  const navigate = useNavigate();

  // Validierungsschema
  const schema = Joi.object({
    swipetype_id: Joi.string().required(),
    name: Joi.string().required(),
    gui_order: Joi.number().required(),
    is_visible_for_view: Joi.boolean().required(),
    is_visible_for_filtering: Joi.boolean().required(),
    is_visible_for_edit: Joi.boolean().required(),
    is_multiple_on_enter: Joi.boolean().required(),
  });

  const {
    reset,
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(schema),
  });

  const loadData = async () => {
    const res = await API.getTaggroup(taggroup_id);
    if (res.status === true) {
      reset({
        swipetype_id: res.data.swipetypes.map((i) => i.id),
        name: res.data.name,
        gui_order: res.data.gui_order,
        is_visible_for_view: res.data.is_visible_for_view,
        is_visible_for_filtering: res.data.is_visible_for_filtering,
        is_visible_for_edit: res.data.is_visible_for_edit,
        is_multiple_on_enter: res.data.is_multiple_on_enter,
      });
    }
  };
  // Load notes when component is rendered the first time
  useEffect(() => {
    if (taggroup_id) {
      loadData();
    }
  }, [taggroup_id]);

  const onSubmit = async (formData) => {
    console.log("TaggroupAddEditSite", formData);

    let result;
    if (taggroup_id) {
      result = await API.updateTaggroup(taggroup_id, formData);
    } else {
      result = await API.createTaggroup(formData);
    }

    console.log("result", result);

    if (result.status === true && result.data.id) {
      console.log("ok");
      // Redirect
      navigate(`/taggroup/${result.data.id}`);
    } else {
      console.log("error");
      // Error
    }
  };

  console.log("Error", errors);

  return (
    <Row>
      <Col>
        <Title>Taggruppe {taggroup_id ? "bearbeiten" : "erstellen"}</Title>
        <Form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
          <Row>
            <Col>
              <SwipetypeForm
                id="swipetype_id"
                label="Swipe-Typ"
                control={control}
                errors={errors}
                multiple
              />
              <InputForm
                id="name"
                label="Name"
                register={register}
                errors={errors}
              />
              <InputForm
                id="gui_order"
                label="GUI-Reihenfolge"
                type="number"
                register={register}
                errors={errors}
              />
              <SwitchForm
                id="is_visible_for_view"
                label="is_visible_for_view"
                register={register}
                errors={errors}
              />

              <SwitchForm
                id="is_visible_for_filtering"
                label="is_visible_for_filtering"
                register={register}
                errors={errors}
              />

              <SwitchForm
                id="is_visible_for_edit"
                label="is_visible_for_edit"
                register={register}
                errors={errors}
              />
              <SwitchForm
                id="is_multiple_on_enter"
                label="is_multiple_on_enter"
                register={register}
                errors={errors}
              />

              <Button
                variant="warning"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                Speichern
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default TaggroupAddEditSite;
